export const getSeoLabel = (text?: string) =>
  text ? `Wynajem Busów Żywiec - ${text}` : undefined;
